export const aadeUiUtils = {
  getInsightPriorityColor(priority: string): string {
    const colors: Record<string, string> = {
      low: "text-blue-600",
      medium: "text-yellow-600",
      high: "text-orange-600",
      critical: "text-red-600",
    };
    return colors[priority] || "text-gray-600";
  },

  getInsightPriorityBadgeColor(priority: string): string {
    const colors: Record<string, string> = {
      low: "bg-blue-100 text-blue-800",
      medium: "bg-yellow-100 text-yellow-800",
      high: "bg-orange-100 text-orange-800",
      critical: "bg-red-100 text-red-800",
    };
    return colors[priority] || "bg-gray-100 text-gray-800";
  },

  getSyncStatusColor(status: string): string {
    const colors: Record<string, string> = {
      pending: "text-gray-600",
      processing: "text-blue-600",
      completed: "text-green-600",
      failed: "text-red-600",
      retrying: "text-yellow-600",
    };
    return colors[status] || "text-gray-600";
  },

  getRiskScoreColor(score: number): string {
    if (score >= 0.8) return "text-red-600";
    if (score >= 0.6) return "text-orange-600";
    if (score >= 0.4) return "text-yellow-600";
    return "text-green-600";
  },

  getRiskScoreLabel(score: number): string {
    if (score >= 0.8) return "Critical Risk";
    if (score >= 0.6) return "High Risk";
    if (score >= 0.4) return "Medium Risk";
    if (score >= 0.2) return "Low Risk";
    return "Minimal Risk";
  },

  formatConfidence(score: number): string {
    return `${(score * 100).toFixed(0)}%`;
  },
};

export default aadeUiUtils;

